module.exports = __webpack_public_path__ + "files/a3.3e0349f2.pdf";